import Vue from 'vue'
// models component
import ShipLogBook from '@/models/ShipLogBook'

export default class ShipLogBookFind {
    // Ship LogBook Find
    static of(shipId, logBookId, params) {
        return Promise.resolve()
            .then(function () {
                return ShipLogBook.api()
                    .find(shipId, logBookId, params)
                    .then(function (result) {
                        console.log(
                            'ShipLogBook.findById()',
                            ShipLogBook.findById(logBookId)
                        )
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
